import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core'

import { AuctionFacade } from 'libs/gb-front/auction/data-access/src'
import { AuthFacade } from 'libs/gb-front/auth/data-access/src'
import * as AuthActions from 'libs/gb-front/auth/data-access/src/lib/+state/auth.actions'
import * as InvoiceActions from 'libs/gb-front/checkout/data-access/src/lib/+state/invoice.actions'
import * as SelectedProfileActions from 'libs/gb-front/selected-profile/data-access/src/lib/+state/selected-profile.actions'
import { InvoiceFacade } from 'libs/gb-front/checkout/data-access/src/lib/+state/invoice.facade'
import { SelectedProfileFacade } from 'libs/gb-front/selected-profile/data-access/src/lib/+state/selected-profile.facade'
import { LoaderFacade } from 'libs/shared/utils/loader/src/lib/+state/loader.facade'
import { LoaderActionTypeEnum } from 'libs/shared/utils/loader/src/lib/+state/loader.models'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'

@UntilDestroy()
@Component({
  selector: 'gb-checkout',
  templateUrl: './gb-checkout.component.html',
  styleUrls: ['./gb-checkout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GbCheckoutComponent implements OnInit {
  auction$ = this.auctionFacade.auction$
  isVolunteer$ = this.authFacade.isVolunteer$
  selectedProfile$ = this.selectedProfileFacade.selectedProfile$
  invoice$ = this.invoiceFacade.invoice$
  isLoading$ = this.loaderFacade.getIsLoading$(LoaderActionTypeEnum.LoadInvoice)
  isEmptyInvoice$ = this.invoiceFacade.isEmptyInvoice$

  onSelectGuestActions = [InvoiceActions.loadInvoiceVolunteer()]

  constructor(
    private auctionFacade: AuctionFacade,
    private authFacade: AuthFacade,
    private selectedProfileFacade: SelectedProfileFacade,
    private loaderFacade: LoaderFacade,
    private invoiceFacade: InvoiceFacade,
  ) {}

  ngOnInit(): void {
    this.selectedProfileFacade.dispatch(SelectedProfileActions.clearSelectedProfileFieldsVolunteer())
    this.authFacade.dispatch(
      AuthActions.checkPromptLogin({
        title: 'CHECKOUT.LOGIN_DIALOG.HEADER',
      }),
    )
    this.authFacade.isGuest$.pipe(untilDestroyed(this)).subscribe((isGuest) => {
      if (isGuest) {
        this.invoiceFacade.dispatch(InvoiceActions.loadInvoice())
      }
    })
  }
}
